module.exports = __webpack_public_path__ + "bring_item.687cd6403ac0ed2b0cc6ca0227dfa8ae.svg";